import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, DatePicker, Form, Select, Spin, Table } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { getAdminLocation } from "../../redux/actions/adminLocation.action.js";
import { getGender } from "../../redux/actions/gender.action.js";
import { CSVLink } from "react-csv";
import Loader from "react-spinners/BarLoader.js";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action.js";
import { getSeason } from "../../redux/actions/season.action.js";
import { getRegion } from "../../redux/actions/region.action.js";
import { getCustomerType } from "../../redux/actions/customerType.action.js";
import { getProfitabilityReport } from "../../redux/actions/profitabilityReport.action.js";
import { getSeasonYear } from "../../redux/actions/seasonYear.action.js";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const ProfitabilityReport = ({ token }) => {
  TabTitle("Profitability Report")
  const {
    gender,
    customerTypes,
    region,
    saleOrderFormData,
    season,
    seasonYear,
    profitabilityReport
  } = useSelector((state) => state);
  const company_id = ReadCookie("defaultCompany");
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const menuId = ReadCookie("menuId");
  const minDate = moment("07-01-2023", "MM-DD-YYYY");

  useEffect(() => {
    dispatch(getGender(token, menuId));
    dispatch(getAdminLocation(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getRegion(token, menuId));
    dispatch(getCustomerType(token));
    dispatch(getSeasonYear(token, menuId));
  }, [dispatch, menuId, token]);



  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      const newData = {
        from_date: moment(values.from_date).format("MM-DD-YYYY"),
        to_date: moment(values.to_date).format("MM-DD-YYYY"),
        gender_id: values.gender_id === "All" || values.gender_id === undefined ? null : values.gender_id,
        customer_type_id: values.cutomer_category === "All" || values.cutomer_category === undefined ? null : values.cutomer_category,
        region_id: values.region === "All" || values.region === undefined ? null : values.region,
        customer_id: values.customer === "All" || values.customer === undefined ? null : values.customer,
        season_id: values.season_id === "All" || values.season_id === undefined ? null : values.season_id,
        original_season_id: (values.org_season_id?.includes("All") || values.org_season_id?.includes(undefined)) ? [106, 108, 107, 110, 251]
          : values.org_season_id === undefined ? null : values.org_season_id,
        new_season_year_id: values.season_year === "All" || values.season_year === undefined ? null : values.season_year,
      };
      dispatch(getProfitabilityReport(token, newData)).then((res) => {
        setLoading(false);
        // if (res?.type === "GET_PROFITABILITY_REPORT_SUCCESS") {
        //   // setLoading(false);
        // }
      });
    }).catch((error) => {
      setLoading(false);
    })
  }




  async function downloadExcelFileData(data) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Profitability Report");

    const excelData = data.map((v) => ({
      "ORG. SSN": v.season_name,
      "CURR. SSN": v.newseason,
      SKU: v.parent_item_code,
      Style: v.style_name,
      Wash: v.wash_name,
      Cost: v.cost_price,
      RTL: v.rate,

      "FP: <15% U SOLD": v.fp_qty,
      "FP: <15% AMNT $": v.fp_amount,
      "FP: <15% AUC": v.fp_auc,
      "FP: <15% % TTL": v.fp_ttl,

      "1ST MD: 16-25% U SOLD": v.first_qty,
      "1ST MD: 16-25% AMNT $": v.first_amount,
      "1ST MD: 16-25% AUC": v.first_auc,
      "1ST MD: 16-25% % TTL": v.first_ttl,

      "2ND MD: 26-40% U SOLD": v.second_qty,
      "2ND MD: 26-40% AMNT $": v.second_amount,
      "2ND MD: 26-40% AUC": v.second_auc,
      "2ND MD: 26-40% % TTL": v.second_ttl,

      "OP: 41-65% U SOLD": v.op_qty,
      "OP: 41-65% AMNT $": v.op_amount,
      "OP: 41-65% AUC": v.op_auc,
      "OP: 41-65% % TTL": v.op_ttl,

      "CLOSEOUT: >65% U SOLD": v.closeout_qty,
      "CLOSEOUT: >65% AMNT $": v.closeout_amount,
      "CLOSEOUT: >65% AUC": v.closeout_auc,
      "CLOSEOUT: >65% % TTL": v.closeout_ttl,

      "FOC U SOLD": v.foc_qty,
      "FOC AMNT $": v.foc_amount,
      "FOC AUC": v.foc_auc,
      "FOC % TTL": v.foc_ttl,

      "TOTAL U SOLD U SOLD": v.total_qty,
      "TOTAL U SOLD AMNT $": v.total_amount,
      "TOTAL U SOLD AUC": v.total_auc,
      "TOTAL U SOLD % TTL": v.total_ttl,

      OTS: v.ots,
      "CUT U": v.cut_qty,
      "CUT @ FP $": v.cut_fp_amount,
      "ST %": v.st_per,
      Action: v.action_name,
    }));

    worksheet.columns = Object.keys(excelData[0] || {}).map((key) => ({
      header: key,
      key,
      width: 20,
    }));

    worksheet.addRows(excelData);

    // Header formatting - Bold + Bottom Border
    worksheet.getRow(1).font = {
      bold: true,
    };

    worksheet.getRow(1).eachCell((cell) => {
      cell.border = {
        bottom: {
          style: "thin",
          color: { argb: "FF000000" },
        },
      };
    });

    // Cost se ST % tak Numeric + Right Align
    const startColumn = worksheet.getColumn("Cost").number;
    const endColumn = worksheet.getColumn("ST %").number;

    for (let col = startColumn; col <= endColumn; col++) {
      const column = worksheet.getColumn(col);

      column.alignment = {
        horizontal: "right",
      };

      column.eachCell((cell, rowNumber) => {
        if (rowNumber === 1) return;

        if (
          cell.value !== null &&
          cell.value !== undefined &&
          cell.value !== ""
        ) {
          const numericValue = Number(cell.value);

          if (Number.isFinite(numericValue)) {
            cell.value = numericValue;
          }
        }
      });
    }

    // Dollar and Percentage Formatting
    worksheet.columns.forEach((column) => {
      const header = column.key;

      const isDollarColumn =
        header === "Cost" ||
        header === "RTL" ||
        header.includes("AMNT $") ||
        header.includes("AUC") ||
        header === "CUT @ FP $";

      if (isDollarColumn) {
        worksheet.getColumn(column.number).eachCell((cell, rowNumber) => {
          if (rowNumber === 1) return;

          if (
            cell.value !== null &&
            cell.value !== undefined &&
            cell.value !== ""
          ) {
            const numericValue = Number(cell.value);

            if (Number.isFinite(numericValue)) {
              cell.value = numericValue;
              cell.numFmt = '$#,##0';
            }
          }
        });
      }

      if (header && (header.includes("% TTL") || header === "ST %")) {
        worksheet.getColumn(column.number).eachCell((cell, rowNumber) => {
          if (rowNumber === 1) return;

          if (
            cell.value !== null &&
            cell.value !== undefined &&
            cell.value !== ""
          ) {
            const value = Number(cell.value);

            if (Number.isFinite(value)) {
              cell.value = value;
              cell.numFmt = '0"%"';
            }
          }
        });
      }
    });

    // Action Column - Red Font
    const actionColumn = worksheet.getColumn("Action");

    actionColumn.eachCell((cell, rowNumber) => {
      if (rowNumber === 1) return;

      cell.font = {
        ...cell.font,
        color: { argb: "FFFF0000" },
      };
    });

    // Only FP TTL column - Font Color
    const fpTtlColumn = worksheet.getColumn("FP: <15% % TTL");

    fpTtlColumn.eachCell((cell, rowNumber) => {
      if (rowNumber === 1) return;

      const value = Number(cell.value);

      let color;

      if (value >= 70) {
        color = "FF008000"; // Green
      } else if (value < 50) {
        color = "FFFF0000"; // Red
      } else {
        color = "FFF0AD00"; // Yellow
      }

      cell.font = {
        bold: true,
        color: { argb: color },
      };
    });

    // OTS Column - Red to Yellow to Green Gradient
    const otsValues = data.map((item) => Number(item.ots) || 0);

    const minOTS = Math.min(...otsValues);
    const maxOTS = Math.max(...otsValues);

    const getOTSColor = (p) => {
      let r, g, b;

      if (p < 50) {
        const ratio = p / 50;

        r = 255;
        g = Math.round(100 + ratio * 155);
        b = Math.round(100 + ratio * 100);
      } else {
        const ratio = (p - 50) / 50;

        r = Math.round(255 - ratio * 171);
        g = 255;
        b = Math.round(200 - ratio * 100);
      }

      const toHex = (value) =>
        value.toString(16).padStart(2, "0");

      return `FF${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
    };

    const otsColumn = worksheet.getColumn("OTS");

    otsColumn.eachCell((cell, rowNumber) => {
      if (rowNumber === 1) return;

      const value = Number(cell.value) || 0;

      const percentage =
        maxOTS === minOTS
          ? 100
          : ((value - minOTS) / (maxOTS - minOTS)) * 100;

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: getOTSColor(percentage),
        },
      };
    });

    // Download Excel
    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
      new Blob([buffer]),
      "Profitability-Report.xlsx"
    );
  }

  const handlePrint = () => {
    window.print();
  };

  const columns = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
      width: "20px",
      fixed: 'left',
    },
    {
      title: "ORG. SSN",
      dataIndex: "season_name",
      key: "season_name",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.season_name.localeCompare(b.season_name)
      },
    },
    {
      title: "CURR. SSN",
      dataIndex: "newseason",
      key: "newseason",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.newseason.localeCompare(b.newseason)
      },
    },
    {
      title: "SKU",
      dataIndex: "parent_item_code",
      key: "parent_item_code",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.parent_item_code.localeCompare(b.parent_item_code)
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.style_name - b.style_name
      },
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.wash_name - b.wash_name
      },
    },
    {
      title: "Cost",
      dataIndex: "cost_price",
      key: "cost_price",
      className: " b_left b_bottom",
      align: "right",
      // fixed: 'left',
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.cost_price - b.cost_price
      },
    },
    {
      title: "RTL",
      dataIndex: "rate",
      key: "rate",
      className: " b_left b_bottom",
      align: "right",
      // fixed: 'left',
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.rate - b.rate
      },
    },
    {
      title: "FP: <15%",
      children: [
        {
          title: "U SOLD",
          dataIndex: "fp_qty",
          key: "fp_qty",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.fp_qty - b.fp_qty;
          },
        },
        {
          title: "AMNT $",
          dataIndex: "fp_amount",
          key: "fp_amount",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            const amount = Number(text);

            return (
              <>
                ${Number.isFinite(amount) ? amount.toLocaleString("en-US") : text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.fp_amount - b.fp_amount;
          },
        },
        {
          title: "AUC",
          dataIndex: "fp_auc",
          key: "fp_auc",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                ${text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.fp_auc - b.fp_auc;
          },
        },
        {
          title: "% TTL",
          dataIndex: "fp_ttl",
          key: "fp_ttl",
          className: "b_left b_bottom",
          align: "right",
          render: (text, record) => {
            let color = "";

            if (text >= 70) {
              color = "green";
            } else if (text < 50) {
              color = "red";
            } else {
              color = "#f0ad00"; // Yellow
            }

            return (
              <span style={{ color: color, fontWeight: "bold" }}>
                {text}%
              </span>
            );
          },
          sorter: (a, b) => a.fp_ttl - b.fp_ttl,
        },
      ]
    },
    {
      title: "1ST MD: 16-25%",
      children: [
        {
          title: "U SOLD",
          dataIndex: "first_qty",
          key: "first_qty",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.first_qty - b.first_qty;
          },
        },
        {
          title: "AMNT $",
          dataIndex: "first_amount",
          key: "first_amount",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            const amount = Number(text);

            return (
              <>
                ${Number.isFinite(amount) ? amount.toLocaleString("en-US") : text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.first_amount - b.first_amount;
          },
        },
        {
          title: "AUC",
          dataIndex: "first_auc",
          key: "first_auc",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                ${text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.first_auc - b.first_auc;
          },
        },
        {
          title: "% TTL",
          dataIndex: "first_ttl",
          key: "first_ttl",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.first_ttl - b.first_ttl;
          },
        },
      ]
    },
    {
      title: "2ND MD: 26-40%",
      children: [
        {
          title: "U SOLD",
          dataIndex: "second_qty",
          key: "second_qty",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.second_qty - b.second_qty;
          },
        },
        {
          title: "AMNT $",
          dataIndex: "second_amount",
          key: "second_amount",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            const amount = Number(text);

            return (
              <>
                ${Number.isFinite(amount) ? amount.toLocaleString("en-US") : text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.second_amount - b.second_amount;
          },
        },
        {
          title: "AUC",
          dataIndex: "second_auc",
          key: "second_auc",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                ${text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.second_auc - b.second_auc;
          },
        },
        {
          title: "% TTL",
          dataIndex: "second_ttl",
          key: "second_ttl",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.second_ttl - b.second_ttl;
          },
        },
      ]
    },
    {
      title: "OP: 41-65%",
      children: [
        {
          title: "U SOLD",
          dataIndex: "op_qty",
          key: "op_qty",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.op_qty - b.op_qty;
          },
        },
        {
          title: "AMNT $",
          dataIndex: "op_amount",
          key: "op_amount",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            const amount = Number(text);

            return (
              <>
                ${Number.isFinite(amount) ? amount.toLocaleString("en-US") : text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.op_amount - b.op_amount;
          },
        },
        {
          title: "AUC",
          dataIndex: "op_auc",
          key: "op_auc",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                ${text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.op_auc - b.op_auc;
          },
        },
        {
          title: "% TTL",
          dataIndex: "op_ttl",
          key: "op_ttl",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.op_ttl - b.op_ttl;
          },
        },
      ]
    },
    {
      title: "CLOSEOUT: >65%",
      children: [
        {
          title: "U SOLD",
          dataIndex: "closeout_qty",
          key: "closeout_qty",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.closeout_qty - b.closeout_qty;
          },
        },
        {
          title: "AMNT $",
          dataIndex: "closeout_amount",
          key: "closeout_amount",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            const amount = Number(text);

            return (
              <>
                ${Number.isFinite(amount) ? amount.toLocaleString("en-US") : text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.closeout_amount - b.closeout_amount;
          },
        },
        {
          title: "AUC",
          dataIndex: "closeout_auc",
          key: "closeout_auc",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                ${text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.closeout_auc - b.closeout_auc;
          },
        },
        {
          title: "% TTL",
          dataIndex: "closeout_ttl",
          key: "closeout_ttl",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.closeout_ttl - b.closeout_ttl;
          },
        },
      ]
    },
    {
      title: "FOC",
      children: [
        {
          title: "U SOLD",
          dataIndex: "foc_qty",
          key: "foc_qty",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.foc_qty - b.foc_qty;
          },
        },
        {
          title: "AMNT $",
          dataIndex: "foc_amount",
          key: "foc_amount",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            const amount = Number(text);

            return (
              <>
                ${Number.isFinite(amount) ? amount.toLocaleString("en-US") : text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.foc_amount - b.foc_amount;
          },
        },
        {
          title: "AUC",
          dataIndex: "foc_auc",
          key: "foc_auc",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                ${text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.foc_auc - b.foc_auc;
          },
        },
        {
          title: "% TTL",
          dataIndex: "foc_ttl",
          key: "foc_ttl",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.foc_ttl - b.foc_ttl;
          },
        },
      ]
    },
    {
      title: "TOTAL U SOLD",
      children: [
        {
          title: "U SOLD",
          dataIndex: "total_qty",
          key: "total_qty",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_qty - b.total_qty;
          },
        },
        {
          title: "AMNT $",
          dataIndex: "total_amount",
          key: "total_amount",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            const amount = Number(text);

            return (
              <>
                ${Number.isFinite(amount) ? amount.toLocaleString("en-US") : text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_amount - b.total_amount;
          },
        },
        {
          title: "AUC",
          dataIndex: "total_auc",
          key: "total_auc",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                ${text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_auc - b.total_auc;
          },
        },
        {
          title: "% TTL",
          dataIndex: "total_ttl",
          key: "total_ttl",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_ttl - b.total_ttl;
          },
        },
      ]
    },
    {
      title: "OTS",
      dataIndex: "ots",
      key: "ots",
      className: "b_left b_bottom",
      align: "right",

      render: (text, record) => {
        const values = profitabilityReport?.payload?.data.map(item => Number(item.ots) || 0);
        const max = Math.max(...values);
        const min = Math.min(...values);

        const percentage = max === min
          ? 100
          : ((Number(text) - min) / (max - min)) * 100;

        // Red → Yellow → Green
        const getColor = (p) => {
          if (p < 50) {
            const ratio = p / 50;
            return `rgb(${255}, ${Math.round(100 + ratio * 155)}, ${Math.round(100 + ratio * 100)})`;
          }

          const ratio = (p - 50) / 50;
          return `rgb(${Math.round(255 - ratio * 171)}, ${255}, ${Math.round(200 - ratio * 100)})`;
        };

        return (
          <div
            style={{
              backgroundColor: getColor(percentage),
              padding: "2px 6px",
              borderRadius: "3px",
              fontWeight: 500,
              textAlign: "right",
            }}
          >
            {text}
          </div>
        );
      },

      sorter: (a, b) => a.ots - b.ots,
    },
    {
      title: "CUT U",
      dataIndex: "cut_qty",
      key: "cut_qty",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.cut_qty - b.cut_qty;
      },
    },
    {
      title: "CUT @ FP $",
      dataIndex: "cut_fp_amount",
      key: "cut_fp_amount",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        const amount = Number(text);

        return (
          <>
            ${Number.isFinite(amount) ? amount.toLocaleString("en-US") : text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.cut_fp_amount - b.cut_fp_amount;
      },
    },
    {
      title: "ST %",
      dataIndex: "st_per",
      key: "st_per",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}%
          </>
        );
      },
      sorter: (a, b) => {
        return a.st_per - b.st_per;
      },
    },
    {
      title: "Action",
      dataIndex: "action_name",
      key: "action_name",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            <span style={{ color: "red" }}>{text}</span>
          </>
        );
      },
      sorter: (a, b) => {
        return a.action_name - b.action_name;
      },
    },
  ];


  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    dispatch(getSaleOrderFormData(token, company_id, menuId, val, ""));
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);


  // Add this handler for org_season
  const handleSeasonChange = (value) => {
    if (value.length === 0) {
      // If list is empty, auto-select "All"
      setTimeout(() => {
        form.setFieldsValue({ org_season_id: ["All"] });
      }, 0);
      return;
    }

    const lastSelected = value[value.length - 1];

    if (lastSelected === "All") {
      // User selected "All", so remove all others
      setTimeout(() => {
        form.setFieldsValue({ org_season_id: ["All"] });
      }, 0);
    } else {
      // User selected something else — remove "All"
      const filtered = value.filter((v) => v !== "All");
      setTimeout(() => {
        form.setFieldsValue({ org_season_id: filtered });
      }, 0);
    }
  };


  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {profitabilityReport?.payload?.data ? (
                          // <CSVLink
                          //   filename={"Profitability-Report.csv"}
                          //   data={excelData}
                          //   onClick={() => { }}
                          // >
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                            onClick={() => downloadExcelFileData(profitabilityReport?.payload?.data)}
                          />
                          // </CSVLink>
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Profitability Report
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>

                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <div className="col-12">
                        <hr className="my-1" />
                        <div className="row">
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="gender_id" className="labels width40">
                                From:
                              </label>
                              <div className=" w-70 fit-selectbox-width">
                                <Form.Item
                                  className="full_date"
                                  name="from_date"
                                  initialValue={moment("07-01-2023", "MM-DD-YYYY")}
                                >
                                  <DatePicker
                                    size="small"
                                    defaultValue={moment().format("MM-DD-YYYY")}
                                    className={"select_Inputs"}
                                    format={"MM-DD-YYYY"}
                                    disabledDate={(current) =>
                                      current && current < minDate.startOf("day")
                                    }
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="gender_id" className="labels width40">
                                To:
                              </label>
                              <div className=" w-70 fit-selectbox-width">
                                <Form.Item
                                  className="full_date"
                                  name="to_date"
                                  initialValue={moment().add(2, 'year').endOf('year')}
                                >
                                  <DatePicker
                                    size="small"
                                    defaultValue={moment().format("MM-DD-YYYY")}
                                    className={"select_Inputs"}
                                    format={"MM-DD-YYYY"}
                                    disabledDate={(current) =>
                                      current && current < minDate.startOf("day")
                                    }
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width40">Gender:</label>
                              <div className=" w-70 fit-selectbox-width">
                                <Form.Item name="gender_id" initialValue={"All"}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value={null}>All</Option>
                                    {gender &&
                                      gender?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.gender_id}>
                                            {it.gender_name}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width40">Cus Type:</label>
                              <div className=" w-70 fit-selectbox-width">
                                <Form.Item name="cutomer_category" initialValue={"All"}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value={null}>All</Option>
                                    {customerTypes?.payload?.data.map((val) => {
                                      return (
                                        <Option key={val.customer_type_id} value={val.customer_type_id}>
                                          {val.customer_type_name}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width40">Region:</label>
                              <div className=" w-70 fit-selectbox-width">
                                <Form.Item name="region" initialValue={"All"}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value={null}>All</Option>
                                    {region &&
                                      region?.payload?.data.map((res, index) => {
                                        return (
                                          <Option
                                            defaultValue={"All"}
                                            key={res.region_id}
                                            value={res.region_id}
                                          >
                                            {res.region_name}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width40">Customer:</label>
                              <div className=" w-70 fit-selectbox-width">
                                <Form.Item name="customer" initialValue={"All"}>
                                  <Select
                                    notFoundContent={
                                      saleOrderFormData.loading ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Loader
                                            type="Oval"
                                            color="#3c4b58"
                                            height={20}
                                            width={20}
                                          />
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",
                                          }}
                                        >
                                          No Data
                                        </div>
                                      )
                                    }
                                    className={"formFullWidth"}
                                    autoComplete={"nope"}
                                    size="small"
                                    showSearch
                                    optionFilterProp="children"
                                    loading={saleOrderFormData.loading}
                                    defaultValue={form.getFieldValue().customer}
                                    onSearch={(value) => {
                                      optimizedFn(value);
                                    }}
                                  >
                                    <Option value="All">All</Option>
                                    {saleOrderFormData?.payload?.customerDetail.map(
                                      (item) => {
                                        return (
                                          <Option
                                            defaultValue={"All"}
                                            key={item.customer_id}
                                            value={item.customer_id}
                                          >
                                            {`${item.customer_name}`}
                                          </Option>
                                        );
                                      }
                                    )}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="row">
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width40">ORG. Season:</label>
                              <div className=" w-70 fit-selectbox-width">
                                <Form.Item name="org_season_id" initialValue={["All"]}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                    mode="multiple"
                                    onChange={handleSeasonChange}
                                    value={form.getFieldValue('org_season_id')}
                                  >
                                    <Option value="All">All</Option>
                                    {season?.payload?.data
                                      ?.filter((status) => [106, 108, 107, 110, 251].includes(status.season_id))
                                      ?.map((status, index) => (
                                        <Option key={index} value={status.season_id}>
                                          {status.season_name}
                                        </Option>
                                      ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width40">ORG. Season Year:</label>
                              <div className=" w-70 fit-selectbox-width">
                                <Form.Item name="season_year" initialValue={"All"}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value={null}>All</Option>
                                    {seasonYear?.payload?.data?.map((res) => (
                                      <Option
                                        key={res.season_year_id}
                                        value={res.season_year_id}
                                      >
                                        {res.season_year}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-4">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width40">CURR. Season:</label>
                              <div className="w-70  fit-selectbox-width">
                                <Form.Item name="season_id" initialValue={"All"}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value={null}>All</Option>
                                    {season &&
                                      season?.payload?.data?.map(
                                        (status, index) => {
                                          return (
                                            <Option
                                              key={index}
                                              value={status.season_id}
                                            >
                                              {status.season_name}
                                            </Option>
                                          );
                                        }
                                      )}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-12 col-md-12">
                            <div className=" d-flex flex-row align-items-baseline">
                              <div style={{ marginTop: "3px", display: "flex", justifyContent: "right", width: '100%' }} >
                                <Button style={{ float: "right" }} type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                                  Search
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content"
        style={{
          // overflowY: "scroll",
          // height: "45vh",
        }}
        ref={tableRef} >
        <div >
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : profitabilityReport?.payload?.data?.length ? (

            <Table
              style={{ fontSize: '10.3px' }}
              className="test04 mt-3 sales_target_report_table sales_report_res_table_intransit ledger_print speciality_customer_size sales_report_res_table dropship-table-height"
              size="small"
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 100,
                pageSizeOptions: [100, 500, 1000]
              }}
              summary={() => {
                const allData = Array.isArray(profitabilityReport?.payload?.data)
                  ? profitabilityReport.payload.data
                  : [];

                const safeNumber = (val) => {
                  const num = parseFloat(val);
                  return isNaN(num) ? 0 : num;
                };
                const sum = (key) => allData.reduce((acc, obj) => acc + safeNumber(obj?.[key]), 0);

                const cutQty = sum("cut_qty");

                // har group ke 4 values: qty, amount, auc, ttl
                const groups = ["fp", "first", "second", "op", "closeout", "foc", "total"].map((g) => {
                  const qty = sum(`${g}_qty`);
                  const amount = sum(`${g}_amount`);
                  return [
                    { value: qty, format: "0,0" },
                    { value: amount, format: "$0,0" },
                    { value: qty ? amount / qty : 0, format: "$0,0" },
                    { value: cutQty ? (qty / cutQty) * 100 : 0, format: "0,0", suffix: "%" },
                  ];
                }).flat();

                const totalQty = sum("total_qty");
                const tail = [
                  { value: sum("ots"), format: "0,0" },
                  { value: cutQty, format: "0,0" },
                  { value: sum("cut_fp_amount"), format: "$0,0" },
                  { value: cutQty ? (totalQty / cutQty) * 100 : 0, format: "0,0", suffix: "%" },
                ];

                const valueCells = [...groups, ...tail]; // index 8 se 39 tak

                const pStyle = {
                  fontWeight: "bolder",
                  textAlign: "right",
                  width: "100%",
                  borderTop: "1px solid black",
                  borderBottom: "1px solid black",
                  fontSize: "11.3px",
                  margin: 0,
                };

                return (
                  <Table.Summary.Row>
                    {/* Fixed left area: index 0-5 ko merge kar ke "Total" */}
                    <Table.Summary.Cell index={0} colSpan={6} className="sales_table_summary">
                      <p style={{ fontWeight: "bolder", textAlign: "right", margin: 0 }}>Total</p>
                    </Table.Summary.Cell>

                    {/* Cost, RTL */}
                    <Table.Summary.Cell index={6} />
                    <Table.Summary.Cell index={7} />

                    {valueCells.map((c, i) => (
                      <Table.Summary.Cell key={i} index={8 + i} className="sales_table_summary">
                        <p style={pStyle}>
                          {numeral(c.value).format(c.format)}
                          {c.suffix || ""}
                        </p>
                      </Table.Summary.Cell>
                    ))}

                    {/* Action column */}
                    <Table.Summary.Cell index={40} />
                  </Table.Summary.Row>
                );
              }}
              bordered
              columns={columns}
              scroll={{ x: "max-content" }}
              dataSource={profitabilityReport?.payload?.data}
            />
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfitabilityReport;

